export default __webpack_public_path__ + "static/18-7c0459e4b276bed0df40239000ef93c8.png";